// extracted by mini-css-extract-plugin
export default {"cls1":"FormGrid_cls1__fqh48","cls2":"FormGrid_cls2__GcHuf FormGrid_cls1__fqh48"};